// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"85c17a2e","977":"ccb2f529"}[chunkId] + ".chunk.js";
};